export default "__VITE_ASSET__Hf6l5HgY__"